export default __webpack_public_path__ + "static/epilogue-e4376f899f58927f6f140e3c3e165716.svg";